// extracted by mini-css-extract-plugin
export default {"container":"LoginForm_container__xSWax","label":"LoginForm_label__pyoHH","button":"LoginForm_button__L60xw","inputContainer":"LoginForm_inputContainer__kWpxa"};